import { Component } from '@angular/core';
import { PageTitleComponent } from '../../../../components/page-title/page-title.component';

@Component({
  selector: 'app-accessibility-statment',
  templateUrl: './accessibility-statment.page.html',
  imports: [PageTitleComponent],
})
export class AccessibilityStatmentPage {}
